export interface InterCompany {
  key: string
  name: string
  isLocal: boolean
}

export interface InterCompanyProject {
  id: number
  name: string
}

export interface InterCompanyProjectGroup {
  company: InterCompany
  projects: InterCompanyProject[]
  hasError: boolean
}

export const ALL_COMPANIES_KEY = 'all'

export interface ReportScope {
  id: number
  name: string
  company: string | null
  projectId: number | null
}
